import { useTheme } from '@mui/material';
import { symbol, symbolTriangle } from 'd3';
import React, { memo } from 'react';

const InvertedTriangle = ({ center, disabled, fill, stroke, ...rest }) => {
	const theme = useTheme();
	const fillColor = disabled ? theme.palette.action.disabled : fill || theme.palette.secondary.main;
	const strokeColor = disabled ? theme.palette.action.disabled : stroke || theme.palette.text.primary;
	return (
		<path
			d={symbol().type(symbolTriangle)()}
			transform={`translate(${center.x},${center.y - 110}) rotate(180)`}
			fill={fillColor}
			stroke={strokeColor}
			strokeWidth={1}
			style={{
				transition: 'all 0.25s 0.25s'
			}}
			{...rest}
		/>
	);
};

export default memo(InvertedTriangle);
